import type { Locale } from "@/lib/i18n";

type L = Record<Locale, string[]>;

export const USE_CASES: Record<string, L> = {
  "koruma-ve-guvenlik": {
    tr: ["Konut & site güvenliği", "AVM ve plaza koruma", "Etkinlik & VIP koruma", "Endüstriyel tesis devriyesi"],
    en: ["Residential security", "Mall & plaza protection", "Event & VIP guarding", "Industrial site patrol"],
    de: ["Wohn- & Anlagensicherheit", "Schutz für Einkaufszentren & Plazas", "Veranstaltungs- & VIP-Schutz", "Patrouille in Industrieanlagen"],
    es: ["Seguridad residencial y de urbanizaciones", "Protección de centros comerciales y plazas", "Protección de eventos y VIP", "Patrullaje de instalaciones industriales"],
    ru: ["Охрана жилых комплексов", "Охрана ТЦ и бизнес-центров", "Охрана мероприятий и VIP", "Патрулирование промышленных объектов"],
    fr: ["Sécurité résidentielle", "Protection centres commerciaux & plazas", "Sécurité événementielle & VIP", "Patrouille de sites industriels"],
    it: ["Sicurezza residenziale", "Protezione centri commerciali e plazas", "Sicurezza eventi e VIP", "Pattugliamento siti industriali"],
  },
  "zirhli-arac-ve-tasima": {
    tr: ["Para & kıymet nakli", "VIP zırhlı araç tahsisi", "Konvoy & güzergâh yönetimi", "Kritik yük taşıma"],
    en: ["Cash & valuables transit", "VIP armored vehicle", "Convoy & route management", "Critical cargo transport"],
    de: ["Geld- & Werttransport", "VIP-Panzerfahrzeug", "Konvoi- & Routenmanagement", "Transport kritischer Güter"],
    es: ["Transporte de valores", "Vehículo blindado VIP", "Gestión de convoyes y rutas", "Transporte de carga crítica"],
    ru: ["Перевозка ценностей", "VIP-бронеавтомобиль", "Колонна и маршрут", "Перевозка критических грузов"],
    fr: ["Transport de valeurs", "Véhicule blindé VIP", "Gestion convoi & itinéraire", "Transport de charges critiques"],
    it: ["Trasporto valori", "Veicolo blindato VIP", "Gestione convogli e percorsi", "Trasporto carichi critici"],
  },
  "tesis-yonetimi": {
    tr: ["Apartman & site yönetimi", "Teknik bakım operasyonu", "Bütçe ve aidat takibi", "Tedarikçi koordinasyonu"],
    en: ["Apartment & complex mgmt.", "Technical maintenance", "Budget & dues tracking", "Vendor coordination"],
    de: ["Wohnanlagenverwaltung", "Technische Wartung", "Budget- & Beitragsverfolgung", "Lieferantenkoordination"],
    es: ["Gestión de edificios y urbanizaciones", "Mantenimiento técnico", "Control de presupuesto y cuotas", "Coordinación de proveedores"],
    ru: ["Управление ЖК и комплексами", "Техническое обслуживание", "Бюджет и взносы", "Координация подрядчиков"],
    fr: ["Gestion d'immeubles & résidences", "Maintenance technique", "Suivi budget & charges", "Coordination des fournisseurs"],
    it: ["Gestione condomini e complessi", "Manutenzione tecnica", "Gestione budget e quote", "Coordinamento fornitori"],
  },
  "ilaclama": {
    tr: ["Haşere & kemirgen kontrolü", "Mutfak & gıda alanları", "Bahçe & dış alan ilaçlama", "Periyodik dezenfeksiyon"],
    en: ["Pest & rodent control", "Kitchen & food areas", "Outdoor area treatment", "Periodic disinfection"],
    de: ["Schädlings- & Nagerbekämpfung", "Küchen- & Lebensmittelbereiche", "Außenbereichsbehandlung", "Regelmäßige Desinfektion"],
    es: ["Control de plagas y roedores", "Cocinas y áreas de alimentos", "Tratamiento de exteriores", "Desinfección periódica"],
    ru: ["Дезинсекция и дератизация", "Кухни и зоны питания", "Обработка наружных территорий", "Периодическая дезинфекция"],
    fr: ["Lutte antiparasitaire & rongeurs", "Cuisines & zones alimentaires", "Traitement des extérieurs", "Désinfection périodique"],
    it: ["Disinfestazione e derattizzazione", "Cucine e aree alimentari", "Trattamento aree esterne", "Disinfezione periodica"],
  },
  "genel-temizlik": {
    tr: ["Ofis & plaza temizliği", "Hastane hijyeni", "İnşaat sonrası temizlik", "Cephe & cam temizliği"],
    en: ["Office & plaza cleaning", "Hospital hygiene", "Post-construction clean", "Facade & window cleaning"],
    de: ["Büro- & Plaza-Reinigung", "Krankenhaushygiene", "Bauendreinigung", "Fassaden- & Glasreinigung"],
    es: ["Limpieza de oficinas y plazas", "Higiene hospitalaria", "Limpieza post-obra", "Limpieza de fachadas y cristales"],
    ru: ["Уборка офисов и БЦ", "Гигиена больниц", "Уборка после ремонта", "Мойка фасадов и окон"],
    fr: ["Nettoyage bureaux & plazas", "Hygiène hospitalière", "Nettoyage après chantier", "Nettoyage façades & vitres"],
    it: ["Pulizia uffici e plazas", "Igiene ospedaliera", "Pulizia post-cantiere", "Pulizia facciate e vetri"],
  },
  "elektronik-guvenlik-sistemleri": {
    tr: ["CCTV kamera sistemleri", "Geçiş kontrol & turnike", "Yangın & alarm sistemleri", "7/24 teknik bakım"],
    en: ["CCTV camera systems", "Access control & turnstiles", "Fire & alarm systems", "24/7 technical support"],
    de: ["CCTV-Kamerasysteme", "Zutrittskontrolle & Drehkreuze", "Brand- & Alarmanlagen", "24/7 technischer Support"],
    es: ["Sistemas CCTV", "Control de acceso y torniquetes", "Sistemas de incendio y alarma", "Soporte técnico 24/7"],
    ru: ["Системы видеонаблюдения", "Контроль доступа и турникеты", "Пожарная и охранная сигнализация", "Техобслуживание 24/7"],
    fr: ["Systèmes CCTV", "Contrôle d'accès & tourniquets", "Incendie & alarmes", "Support technique 24/7"],
    it: ["Sistemi TVCC", "Controllo accessi e tornelli", "Sistemi antincendio e allarme", "Assistenza tecnica 24/7"],
  },
};

export const USE_CASES_LABEL: Record<Locale, string> = {
  tr: "Kullanım Alanları",
  en: "Use Cases",
  de: "Einsatzbereiche",
  es: "Casos de Uso",
  ru: "Сферы применения",
  fr: "Cas d'usage",
  it: "Casi d'uso",
};

export function getUseCases(slug: string, locale: Locale): string[] {
  const row = USE_CASES[slug];
  if (!row) return [];
  return row[locale] || row.tr || [];
}
